export default __webpack_public_path__ + "static/media/reg_icon.44bfdd7c.png";